import { render } from "./ReviewList.vue?vue&type=template&id=6a333b99&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=6a333b99&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a333b99"]])

export default __exports__